module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"editEvent":"Edit the event","eventName":"On which occasion?","edit":"Edit","deleteEvent":"Delete the event","cancel":"Cancel","eventDeleted":"The event deleted successfully.","eventUpdated":"The event has been updated successfully."},"fr_FR":{"editEvent":"Modifier l\u0027événement","eventName":"Pour quelle occasion ?","edit":"Éditer","deleteEvent":"Supprimer l\u0027événement","cancel":"Annuler","eventDeleted":"Événement supprimé avec succès.","eventUpdated":"Événement mis à jour avec succès."}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/components/event-edit-form.json
// module id = 189
// module chunks = 1